// src/components/ViecNhoBan.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { fetchData } from "../services/api";
import { veDangNgay } from "../utils/ngay";

// ============================================================
// 👋 "NGƯỜI NHÀ ĐANG NHỜ BẠN"
// ------------------------------------------------------------
// Khối này trả lời đúng một câu hỏi của chủ nhà: "làm sao để biết người
// khác nhờ mình?" — trước đây nhờ xong mà người kia không mở đúng tab
// Việc nhà thì không có gì báo cho họ biết cả.
//
// ⚠️ ĐÂY LÀ TIN BÁO, KHÔNG PHẢI CHỖ PHÂN VIỆC.
// Theo quyết định số 1 trong tài liệu chân dung: bảng tin là tin nóng cả
// nhà cùng đọc, KHÔNG giao việc ở đó. Vì vậy khối này cố ý KHÔNG có nút
// "Đã làm", không có nút sửa, không có nút xóa — chỉ có một đường dẫn
// sang trang Việc nhà. Đừng thêm nút vào đây; thêm là bảng tin lại biến
// thành bảng phân việc, đúng cái đã bỏ.
// ============================================================

const homNay = () => {
  const d = new Date();
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
};

const soNgayTre = (v) => {
  if (!v.due_date) return 0;
  const han = new Date(veDangNgay(v.due_date) + "T00:00:00");
  return Math.round((homNay() - han) / 86400000);
};

const veNgay = (v) => (v ? new Date(v).toLocaleDateString("vi-VN") : "");

// ============================================================
// 🔔 VIỆC ĐẾN NGÀY NHẮC — Đợt N4, 14/09/2026
// ------------------------------------------------------------
// Anh chốt (câu 3): việc nhà đến ngày nhắc KHÔNG hiện ở khung "Nhắc nhở hôm
// nay" nữa, mà được ĐẨY LÊN ĐẦU khối này, tô nền vàng, gắn 🔔. Khối này vốn
// đã liệt kê mọi việc chưa làm — vẽ ở cả hai chỗ là một việc hiện hai lần.
//
// "Việc nào đang có chuông" hỏi MÁY CHỦ qua /api/reminders (hàng đợi
// `nhac_nho`), KHÔNG tự so `v.reminder <= hôm nay` ở đây. Tự so là dựng lại
// một cơ chế nhắc thứ hai trong trình duyệt — đúng thứ N4 đi gỡ.
// Lấy lời nhắc hỏng thì khối vẫn hiện danh sách việc, chỉ không có chuông.
// ============================================================
function ViecNhoBan({ user }) {
  const [ds, setDs] = useState([]);
  const [dangTai, setDangTai] = useState(true);

  useEffect(() => {
    Promise.all([
      fetchData("viec"),
      fetchData("reminders").catch(() => []),
    ])
      .then(([viec, nhac]) => {
        const coChuong = new Set(
          (Array.isArray(nhac) ? nhac : [])
            .filter((n) => n.loai_nguon === "task")
            .map((n) => n.nguon_id),
        );
        const cuaToi = viec
          .filter((v) => v.nguoi_phu_trach === user.id && !v.done)
          .map((v) => ({ ...v, coChuong: coChuong.has(v.id) }))
          .sort((a, b) => {
            // Việc có chuông lên đầu (anh duyệt mockup 14/09).
            if (a.coChuong !== b.coChuong) return a.coChuong ? -1 : 1;
            // Rồi việc có hạn, hạn gần lên trên. Việc chưa đặt hạn xuống
            // cuối — không có hạn thì không có gì gấp.
            if (!a.due_date && !b.due_date) return 0;
            if (!a.due_date) return 1;
            if (!b.due_date) return -1;
            return a.due_date < b.due_date ? -1 : 1;
          });
        setDs(cuaToi);
      })
      .catch(() => setDs([]))
      .finally(() => setDangTai(false));
  }, [user.id]);

  if (dangTai) return null;

  if (ds.length === 0) {
    return (
      <div className="nho-ban nho-ban-trong">
        ✅ Không có việc nào đang chờ bạn.
      </div>
    );
  }

  const hienThi = ds.slice(0, 5);
  const conLai = ds.length - hienThi.length;

  return (
    <div className="nho-ban">
      <h3 className="nho-ban-tieu-de">
        👋 Người nhà đang nhờ bạn ({ds.length})
      </h3>

      <ul className="nho-ban-danh-sach">
        {hienThi.map((v) => {
          const tre = soNgayTre(v);
          return (
            <li
              key={v.id}
              className={`nho-ban-dong ${v.coChuong ? "nho-ban-chuong" : ""}`}
            >
              {v.coChuong && (
                <span className="nho-ban-chuong-chu">🔔 Đến ngày nhắc</span>
              )}
              <span className="nho-ban-ai">
                {v.ten_nguoi_nho || "Ai đó"} nhờ:
              </span>{" "}
              <strong>{v.name}</strong>
              {v.due_date && (
                <span className="nho-ban-han"> · hạn {veNgay(v.due_date)}</span>
              )}
              {tre > 0 && <span className="nho-ban-tre"> · trễ {tre} ngày</span>}
            </li>
          );
        })}
      </ul>

      {conLai > 0 && (
        <p className="nho-ban-con-lai">…và {conLai} việc nữa.</p>
      )}

      <Link to="/viec-nha" className="nho-ban-lien-ket">
        Mở trang Việc nhà →
      </Link>
    </div>
  );
}

export default ViecNhoBan;
